/* eslint-disable no-debugger */
import { AxiosResponse } from "axios";

import { IPaginatedResponse } from "../@types/PaginatedResponse";
import { IPatientClinicianForm, ISurveysFormsReponse } from "../@types/Proms";
import { api } from "./api";

const baseUrl = "portal/Surveys";

export const promsService = {
  async getPatientProms(
    patientId: number
  ): Promise<AxiosResponse<IPaginatedResponse<any>>> {
    const url = "/Portal/Surveys";

    const urlParamsParsed = new URLSearchParams();

    urlParamsParsed.append("patientId", patientId.toString());

    const promsResponse = await api.get<IPaginatedResponse<any>>(url, {
      params: urlParamsParsed,
    });

    return promsResponse;
  },

  async getPatientSurveyForms(
    patientId: number,
    surveyId: number,
    fromDate: string,
    toDate: string
  ): Promise<AxiosResponse<ISurveysFormsReponse>> {
    const url = `/Portal/Surveys/PatientSurveyAnswers`;

    const surveyFormsResponse = await api.post<ISurveysFormsReponse>(url, {
      patientId,
      surveyId,
      fromDate,
      toDate,
    });

    return surveyFormsResponse;
  },

  async getPatientClinicanForms(
    patientId: string
  ): Promise<AxiosResponse<IPaginatedResponse<IPatientClinicianForm[]>>> {
    const url = "/Portal/Surveys/ClinicianForms";

    const urlParamsParsed = new URLSearchParams();

    urlParamsParsed.append("patientId", patientId);

    const patientClinicianForms = await api.get<
      IPaginatedResponse<IPatientClinicianForm[]>
    >(url, {
      params: urlParamsParsed,
    });

    return patientClinicianForms;
  },

  async getPatientPromsPaginated(
    patientId: number,
    page?: number,
    pageSize?: number,
    surveyType?: "Patient" | "Clinician"
  ): Promise<AxiosResponse<IPaginatedResponse<any>>> {
    const url = "/Portal/Surveys";

    const params: Record<string, string | number> = {
      patientId,
    };

    if (page !== undefined) {
      params.page = page;
    }
    if (pageSize !== undefined) {
      params.pageSize = pageSize;
    }
    if (surveyType !== undefined) {
      params.surveyType = surveyType;
    }

    return api.get<IPaginatedResponse<any>>(url, { params });
  },

  async getPatientClinicianFormsPaginated(
    patientId: number,
    page?: number,
    pageSize?: number
  ): Promise<AxiosResponse<IPaginatedResponse<IPatientClinicianForm[]>>> {
    const url = "/Portal/Surveys/ClinicianForms";

    const params: Record<string, string | number> = {
      patientId,
    };

    if (page !== undefined) {
      params.page = page;
    }
    if (pageSize !== undefined) {
      params.pageSize = pageSize;
    }

    return api.get<IPaginatedResponse<IPatientClinicianForm[]>>(url, {
      params,
    });
  },

  async archiveFormAnswer(surveyAnswerId: string): Promise<AxiosResponse> {
    const url = `${baseUrl}/ClinicianForms/${surveyAnswerId}/Archive`;

    const patientClinicianForms = await api.post(url);

    return patientClinicianForms;
  },

  async downloadMedia(path: string): Promise<AxiosResponse> {
    const url = `${baseUrl}/Media/Download`;

    const media = await api.post(
      url,
      {
        key: path,
      },
      { responseType: "blob" }
    );

    return media;
  },

  async getMediaPreviewLink(path: string): Promise<AxiosResponse> {
    const url = `${baseUrl}/Media/Preview`;

    const mediaPreviewLink = await api.post(url, {
      key: path,
    });

    return mediaPreviewLink;
  },
};
